import React, { useState } from 'react';
import AdSpaceApiTokensAdminList from './components/ApitTokensAdminList';
import AdSpaceApiTokensAdminAddApiTokenPage from './components/ApiTokensAdminAddApiTokenPage';
import { Box, Tabs, Tab } from '@mui/material';


const AdSpaceApiTokensAdminPage: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tab} onChange={handleTabChange} aria-label="AdSpaces admin tabs">
        <Tab label="List Api Tokens" />
        <Tab label="Insert Api Token" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <AdSpaceApiTokensAdminList />}
        {tab === 1 && <AdSpaceApiTokensAdminAddApiTokenPage />}
      </Box>
    </Box>
  );
};

export default AdSpaceApiTokensAdminPage;